import "@babel/polyfill";
import { narative_slider } from "./modules/narative";

// narative
narative_slider();
